import { z } from "zod";

import { validateEircode } from "utils/validators";

export const formSchema = z.object({
  consultationDate: z.string().min(1, { message: "Please provide consultation date." }),
  eircode: z
    .string()
    .min(1, { message: "Please provide eircode." })
    .refine(
      (val) => validateEircode(val).isValid,
      (val) => ({ message: validateEircode(val).error || "Invalid Eircode format" })
    ),
  ethnicityCode: z.string().optional(),
  contractDoctor: z
    .string({ required_error: "Please provide contract doctor." })
    .min(1, { message: "Please provide contract doctor." }),

  diabetesType2: z.boolean().optional().default(false),
  asthma: z.boolean().optional().default(false),
  copd: z.boolean().optional().default(false),
  heartFailure: z.boolean().optional().default(false),
  atrialFibrillation: z.boolean().optional().default(false),
  ischaemicHeartDisease: z.boolean().optional().default(false),
  stroke: z.boolean().optional().default(false),
  tia: z.boolean().optional().default(false),

  diabetesType2Year: z.string().optional(),
  asthmaYear: z.string().optional(),
  copdYear: z.string().optional(),
  heartFailureYear: z.string().optional(),
  atrialFibrillationYear: z.string().optional(),
  ischaemicHeartDiseaseYear: z.string().optional(),
  strokeYear: z.string().optional(),
  tiaYear: z.string().optional(),

  diabetesType2AttendingHospital: z.boolean().optional().default(false),
  asthmaAttendingHospital: z.boolean().optional().default(false),
  copdAttendingHospital: z.boolean().optional().default(false),
  heartFailureAttendingHospital: z.boolean().optional().default(false),
  atrialFibrillationAttendingHospital: z.boolean().optional().default(false),
  ischaemicHeartDiseaseAttendingHospital: z.boolean().optional().default(false),
  strokeAttendingHospital: z.boolean().optional().default(false),
  tiaAttendingHospital: z.boolean().optional().default(false),

  // Ref 14 — Other Major Diagnoses (multi-select + free text). All optional.
  myocardialInfarction: z.boolean().optional().default(false),
  dementia: z.boolean().optional().default(false),
  cancerStage2Plus: z.boolean().optional().default(false),
  seriousMobilityIssues: z.boolean().optional().default(false),
  chronicKidneyDisease: z.boolean().optional().default(false),
  significantMentalIllness: z.boolean().optional().default(false),
  hypertensionOnTreatment: z.boolean().optional().default(false),
  inflammatoryArthritis: z.boolean().optional().default(false),
  otherMajorDiagnosisOtherText: z.string().optional(),
});
